import { useMemo } from 'react';

import { EMPTY_OBJECT } from '../../../constants';
import { LabelTheme } from '../types';

export const useLabelTheme = (theme: Partial<LabelTheme> = EMPTY_OBJECT): LabelTheme => {
  return useMemo(
    () => ({
      font_size: '13px',
      font_family: "'Roboto', sans-serif;",
      line_height: '13px',
      ...theme,
    }),
    [theme]
  );
};
